import React, { FC } from 'react'
import { useTranslate, Translate } from '@/utils/translate/translate-client'
import { GFooterMD, GResponsiveText, GTitleSM, GTitleXS } from '../UI/Typography'

interface NavigationItem {
  name: string
  onClick: () => void
}

interface FooterNavigationProps {
  siteNavigation: NavigationItem[]
}

export const FooterNavigation: FC<FooterNavigationProps> = ({ siteNavigation }) => {
  const { t } = useTranslate('tickets')

  return (
    <div className="shrink-0">
      <GResponsiveText
        className="!font-medium"
        color="white"
        MobileTextComponent={GTitleXS}
        DesktopTextComponent={GTitleSM}
      >
        {t('siteNavigation', 'Site Navigation')}
      </GResponsiveText>

      <ul className="mt-2 flex flex-col gap-1 md:mt-3">
        {siteNavigation.map((item) => (
          <li className="cursor-pointer" onClick={() => item.onClick()} key={item.name}>
            <GFooterMD color="white" className="underline">
              {item.name}
            </GFooterMD>
          </li>
        ))}
      </ul>

      <GFooterMD className="mt-10 block" color="white">
        <Translate t={t} i18nKey="footerCopyright">
          © 2025 Angel, LLC. All rights reserved.
        </Translate>
      </GFooterMD>
    </div>
  )
}
